import type { ReactNode } from "react";
import { DesktopSidebar } from "./DesktopSidebar";
import { SidebarProvider, useSidebar } from "@/context/SidebarContext";
import { cn } from "@/lib/utils";

export function DesktopLayout({ children }: { children: ReactNode }) {
  return (
    <SidebarProvider>
      <div className="min-h-screen bg-background text-foreground">
        <DesktopSidebar />
        <DesktopMain>{children}</DesktopMain>
      </div>
    </SidebarProvider>
  );
}

function DesktopMain({ children }: { children: ReactNode }) {
  const { collapsed } = useSidebar();
  return (
    <main
      className={cn(
        "min-h-screen transition-[margin-left] duration-500 ease-in-out",
        collapsed ? "ml-16" : "ml-60",
      )}
    >
      {children}
    </main>
  );
}
